import { IStepProps } from './CheckoutProgressBar.types';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';

export const useStepStyles = makeStyles({
    root: {
        width: '12%',
        userSelect: 'none',
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase400
    },
    previous: {
        cursor: 'pointer'
    }
});

export const Step = (props: IStepProps) => {
    const { step, index } = props;

    const { updateCartStepIndex } = useCart();

    const styles = useStepStyles();

    if (step === 'start')
        return (
            <div
                className={mergeClasses(styles.root, styles.previous)}
                onClick={() => updateCartStepIndex(index)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === 'Space') updateCartStepIndex(index);
                }}
            >
                <StartStep {...props} />
            </div>
        );

    if (step === 'previous')
        return (
            <div className={mergeClasses(styles.root)}>
                <PreviousStep {...props} />
            </div>
        );

    if (step === 'current')
        return (
            <div className={styles.root}>
                <CurrentStep {...props} />
            </div>
        );

    if (step === 'last')
        return (
            <div className={styles.root}>
                <LastStep {...props} />
            </div>
        );

    if (step === 'future')
        return (
            <div className={styles.root}>
                <FutureStep {...props} />
            </div>
        );

    return (
        <div className={styles.root}>
            <CurrentLastStep {...props} />
        </div>
    );
};

export const StartStep = (props: IStepProps) => {
    const { text } = props;

    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 188 60' fill='none'>
            <g filter='url(#filter0_d_8996_3232)'>
                <mask id='path-1-inside-1_8996_3232' fill='white'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M0 5C0 2.79086 1.79086 1 4 1H167.679C169.114 1 170.44 1.76914 171.152 3.01544L184.866 27.0154C185.569 28.2452 185.569 29.7548 184.866 30.9846L171.152 54.9846C170.44 56.2309 169.114 57 167.679 57H4C1.79086 57 0 55.2091 0 53V5Z'
                    />
                </mask>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 5C0 2.79086 1.79086 1 4 1H167.679C169.114 1 170.44 1.76914 171.152 3.01544L184.866 27.0154C185.569 28.2452 185.569 29.7548 184.866 30.9846L171.152 54.9846C170.44 56.2309 169.114 57 167.679 57H4C1.79086 57 0 55.2091 0 53V5Z'
                    fill='#CEE2F5'
                />
                <path
                    d='M184.866 27.0154L185.734 26.5193V26.5193L184.866 27.0154ZM184.866 30.9846L185.734 31.4807V31.4807L184.866 30.9846ZM171.152 54.9846L172.02 55.4807L171.152 54.9846ZM171.152 3.01544L172.02 2.51931L171.152 3.01544ZM167.679 0H4V2H167.679V0ZM170.283 3.51158L183.998 27.5116L185.734 26.5193L172.02 2.51931L170.283 3.51158ZM183.998 27.5116C184.525 28.4339 184.525 29.5661 183.998 30.4884L185.734 31.4807C186.613 29.9435 186.613 28.0565 185.734 26.5193L183.998 27.5116ZM183.998 30.4884L170.283 54.4884L172.02 55.4807L185.734 31.4807L183.998 30.4884ZM4 58H167.679V56H4V58ZM-1 5V53H1V5H-1ZM170.283 54.4884C169.749 55.4231 168.755 56 167.679 56V58C169.473 58 171.13 57.0386 172.02 55.4807L170.283 54.4884ZM4 0C1.23858 0 -1 2.23858 -1 5H1C1 3.34315 2.34315 2 4 2V0ZM4 56C2.34315 56 1 54.6569 1 53H-1C-1 55.7614 1.23858 58 4 58V56ZM167.679 2C168.755 2 169.749 2.57686 170.283 3.51158L172.02 2.51931C171.13 0.96143 169.473 0 167.679 0V2Z'
                    fill='#0A6FCD'
                    mask='url(#path-1-inside-1_8996_3232)'
                />
            </g>
            <text x='90' y='30' fill='black' textAnchor='middle' dominantBaseline='middle'>
                {text}
            </text>
            <defs>
                <filter
                    id='filter0_d_8996_3232'
                    x='-2'
                    y='0'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='1' />
                    <feGaussianBlur stdDeviation='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_8996_3232'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_8996_3232'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const PreviousStep = (props: IStepProps) => {
    const { text } = props;

    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 188 60' fill='none'>
            <g filter='url(#filter0_d_8996_3240)'>
                <mask id='path-1-inside-1_8996_3240' fill='white'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M170.652 3.01544C169.94 1.76914 168.614 1 167.179 1H6.39275C3.32146 1 1.39599 4.31793 2.91978 6.98456L14.366 27.0154C15.0687 28.2452 15.0687 29.7548 14.366 30.9846L2.91978 51.0154C1.39599 53.6821 3.32146 57 6.39275 57H167.179C168.614 57 169.94 56.2309 170.652 54.9846L184.366 30.9846C185.069 29.7548 185.069 28.2452 184.366 27.0154L170.652 3.01544Z'
                    />
                </mask>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M170.652 3.01544C169.94 1.76914 168.614 1 167.179 1H6.39275C3.32146 1 1.39599 4.31793 2.91978 6.98456L14.366 27.0154C15.0687 28.2452 15.0687 29.7548 14.366 30.9846L2.91978 51.0154C1.39599 53.6821 3.32146 57 6.39275 57H167.179C168.614 57 169.94 56.2309 170.652 54.9846L184.366 30.9846C185.069 29.7548 185.069 28.2452 184.366 27.0154L170.652 3.01544Z'
                    fill='#CEE2F5'
                />
                <path
                    d='M14.366 27.0154L13.4978 27.5116L14.366 27.0154ZM14.366 30.9846L13.4978 30.4884L14.366 30.9846ZM184.366 30.9846L185.234 31.4807V31.4807L184.366 30.9846ZM184.366 27.0154L185.234 26.5193V26.5193L184.366 27.0154ZM170.652 3.01544L171.52 2.51931L170.652 3.01544ZM170.652 54.9846L171.52 55.4807L170.652 54.9846ZM6.39275 2H167.179V0H6.39275V2ZM15.2342 26.5193L3.78802 6.48842L2.05154 7.4807L13.4978 27.5116L15.2342 26.5193ZM15.2342 31.4807C16.1126 29.9435 16.1126 28.0565 15.2342 26.5193L13.4978 27.5116C14.0248 28.4339 14.0248 29.5661 13.4978 30.4884L15.2342 31.4807ZM3.78802 51.5116L15.2342 31.4807L13.4978 30.4884L2.05154 50.5193L3.78802 51.5116ZM167.179 56H6.39275V58H167.179V56ZM183.498 30.4884L169.783 54.4884L171.52 55.4807L185.234 31.4807L183.498 30.4884ZM183.498 27.5116C184.025 28.4339 184.025 29.5661 183.498 30.4884L185.234 31.4807C186.113 29.9435 186.113 28.0565 185.234 26.5193L183.498 27.5116ZM169.783 3.51158L183.498 27.5116L185.234 26.5193L171.52 2.51931L169.783 3.51158ZM2.05154 50.5193C0.146802 53.8526 2.55364 58 6.39275 58V56C4.08928 56 2.64518 53.5116 3.78802 51.5116L2.05154 50.5193ZM167.179 2C168.255 2 169.249 2.57686 169.783 3.51158L171.52 2.51931C170.63 0.96143 168.973 0 167.179 0V2ZM167.179 58C168.973 58 170.63 57.0386 171.52 55.4807L169.783 54.4884C169.249 55.4231 168.255 56 167.179 56V58ZM6.39275 0C2.55364 0 0.146803 4.14741 2.05154 7.4807L3.78802 6.48842C2.64518 4.48845 4.08928 2 6.39275 2V0Z'
                    fill='#0A6FCD'
                    mask='url(#path-1-inside-1_8996_3240)'
                />
            </g>
            <text x='94' y='30' fill='black' textAnchor='middle' dominantBaseline='middle'>
                {text}
            </text>
            <defs>
                <filter
                    id='filter0_d_8996_3240'
                    x='0.386841'
                    y='0'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='1' />
                    <feGaussianBlur stdDeviation='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_8996_3240'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_8996_3240'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const CurrentStep = (props: IStepProps) => {
    const { text } = props;

    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 188 60' fill='none'>
            <g filter='url(#filter0_d_8996_3250)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M171.152 3.01544C170.439 1.76914 169.114 1 167.679 1H6.89263C3.82134 1 1.89587 4.31793 3.41966 6.98456L14.8659 27.0154C15.5686 28.2452 15.5686 29.7548 14.8659 30.9846L3.41966 51.0154C1.89587 53.6821 3.82134 57 6.89263 57H167.679C169.114 57 170.439 56.2309 171.152 54.9846L184.866 30.9846C185.569 29.7548 185.569 28.2452 184.866 27.0154L171.152 3.01544Z'
                    fill='#0A6FCD'
                />
            </g>
            <text x='94' y='30' fill='white' textAnchor='middle' dominantBaseline='middle'>
                {text}
            </text>
            <defs>
                <filter
                    id='filter0_d_8996_3250'
                    x='0.886719'
                    y='0'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='1' />
                    <feGaussianBlur stdDeviation='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_8996_3250'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_8996_3250'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const FutureStep = (props: IStepProps) => {
    const { text } = props;

    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 188 60' fill='none'>
            <g filter='url(#filter0_d_8996_5495)'>
                <mask id='path-1-inside-1_8996_5495' fill='white'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M171.152 3.01544C170.439 1.76914 169.114 1 167.679 1H6.89263C3.82134 1 1.89587 4.31793 3.41966 6.98456L14.8659 27.0154C15.5686 28.2452 15.5686 29.7548 14.8659 30.9846L3.41966 51.0154C1.89587 53.6821 3.82134 57 6.89263 57H167.679C169.114 57 170.439 56.2309 171.152 54.9846L184.866 30.9846C185.569 29.7548 185.569 28.2452 184.866 27.0154L171.152 3.01544Z'
                    />
                </mask>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M171.152 3.01544C170.439 1.76914 169.114 1 167.679 1H6.89263C3.82134 1 1.89587 4.31793 3.41966 6.98456L14.8659 27.0154C15.5686 28.2452 15.5686 29.7548 14.8659 30.9846L3.41966 51.0154C1.89587 53.6821 3.82134 57 6.89263 57H167.679C169.114 57 170.439 56.2309 171.152 54.9846L184.866 30.9846C185.569 29.7548 185.569 28.2452 184.866 27.0154L171.152 3.01544Z'
                    fill='white'
                />
                <path
                    d='M14.8659 27.0154L13.9976 27.5116L14.8659 27.0154ZM14.8659 30.9846L13.9976 30.4884L14.8659 30.9846ZM184.866 30.9846L185.734 31.4807V31.4807L184.866 30.9846ZM184.866 27.0154L185.734 26.5193V26.5193L184.866 27.0154ZM171.152 3.01544L172.02 2.51931L171.152 3.01544ZM171.152 54.9846L172.02 55.4807L171.152 54.9846ZM6.89263 2H167.679V0H6.89263V2ZM15.7341 26.5193L4.2879 6.48842L2.55141 7.4807L13.9976 27.5116L15.7341 26.5193ZM15.7341 31.4807C16.6125 29.9435 16.6125 28.0565 15.7341 26.5193L13.9976 27.5116C14.5247 28.4339 14.5247 29.5661 13.9976 30.4884L15.7341 31.4807ZM4.2879 51.5116L15.7341 31.4807L13.9976 30.4884L2.55141 50.5193L4.2879 51.5116ZM167.679 56H6.89263V58H167.679V56ZM183.998 30.4884L170.283 54.4884L172.02 55.4807L185.734 31.4807L183.998 30.4884ZM183.998 27.5116C184.525 28.4339 184.525 29.5661 183.998 30.4884L185.734 31.4807C186.612 29.9435 186.612 28.0565 185.734 26.5193L183.998 27.5116ZM170.283 3.51158L183.998 27.5116L185.734 26.5193L172.02 2.51931L170.283 3.51158ZM2.55141 50.5193C0.64668 53.8526 3.05352 58 6.89263 58V56C4.58916 56 3.14506 53.5116 4.2879 51.5116L2.55141 50.5193ZM167.679 2C168.755 2 169.749 2.57686 170.283 3.51158L172.02 2.51931C171.13 0.96143 169.473 0 167.679 0V2ZM167.679 58C169.473 58 171.13 57.0386 172.02 55.4807L170.283 54.4884C169.749 55.4231 168.755 56 167.679 56V58ZM6.89263 0C3.05352 0 0.646681 4.14741 2.55141 7.4807L4.2879 6.48842C3.14506 4.48845 4.58916 2 6.89263 2V0Z'
                    fill='#C6C6C6'
                    mask='url(#path-1-inside-1_8996_5495)'
                />
            </g>
            <text x='94' y='30' fill='black' textAnchor='middle' dominantBaseline='middle'>
                {text}
            </text>
            <defs>
                <filter
                    id='filter0_d_8996_5495'
                    x='0.886719'
                    y='0'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='1' />
                    <feGaussianBlur stdDeviation='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_8996_5495'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_8996_5495'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const LastStep = (props: IStepProps) => {
    const { text } = props;

    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 188 60' fill='none'>
            <g filter='url(#filter0_d_8996_5504)'>
                <mask id='path-1-inside-1_8996_5504' fill='white'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M2.91966 6.98456C1.39587 4.31793 3.32134 1 6.39263 1H165.5C167.709 1 169.5 2.79086 169.5 5V53C169.5 55.2091 167.709 57 165.5 57H6.39263C3.32134 57 1.39587 53.6821 2.91966 51.0154L14.3659 30.9846C15.0686 29.7548 15.0686 28.2452 14.3659 27.0154L2.91966 6.98456Z'
                    />
                </mask>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M2.91966 6.98456C1.39587 4.31793 3.32134 1 6.39263 1H165.5C167.709 1 169.5 2.79086 169.5 5V53C169.5 55.2091 167.709 57 165.5 57H6.39263C3.32134 57 1.39587 53.6821 2.91966 51.0154L14.3659 30.9846C15.0686 29.7548 15.0686 28.2452 14.3659 27.0154L2.91966 6.98456Z'
                    fill='white'
                />
                <path
                    d='M14.3659 30.9846L13.4976 30.4884L14.3659 30.9846ZM14.3659 27.0154L13.4976 27.5116L14.3659 27.0154ZM2.91966 51.0154L2.05141 50.5193L2.91966 51.0154ZM2.91966 6.98456L2.05141 7.48069L2.91966 6.98456ZM165.5 0H6.39263V2H165.5V0ZM170.5 53V5H168.5V53H170.5ZM6.39263 58H165.5V56H6.39263V58ZM13.4976 30.4884L2.05141 50.5193L3.7879 51.5116L15.2341 31.4807L13.4976 30.4884ZM13.4976 27.5116C14.0247 28.4339 14.0247 29.5661 13.4976 30.4884L15.2341 31.4807C16.1125 29.9435 16.1125 28.0565 15.2341 26.5193L13.4976 27.5116ZM2.05141 7.48069L13.4976 27.5116L15.2341 26.5193L3.7879 6.48842L2.05141 7.48069ZM6.39263 56C4.08916 56 2.64506 53.5116 3.7879 51.5116L2.05141 50.5193C0.14668 53.8526 2.55352 58 6.39263 58V56ZM168.5 53C168.5 54.6569 167.157 56 165.5 56V58C168.261 58 170.5 55.7614 170.5 53H168.5ZM6.39263 0C2.55352 0 0.14668 4.14741 2.05141 7.48069L3.7879 6.48842C2.64506 4.48845 4.08916 2 6.39263 2V0ZM165.5 2C167.157 2 168.5 3.34315 168.5 5H170.5C170.5 2.23858 168.261 0 165.5 0V2Z'
                    fill='#C6C6C6'
                    mask='url(#path-1-inside-1_8996_5504)'
                />
            </g>
            <text x='94' y='30' fill='black' textAnchor='middle' dominantBaseline='middle'>
                {text}
            </text>
            <defs>
                <filter
                    id='filter0_d_8996_5504'
                    x='0.386719'
                    y='0'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='1' />
                    <feGaussianBlur stdDeviation='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_8996_5504'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_8996_5504'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const CurrentLastStep = (props: IStepProps) => {
    const { text } = props;

    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 188 60' fill='none'>
            <g filter='url(#filter0_d_8996_5767)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M2.91966 6.98456C1.39587 4.31793 3.32134 1 6.39263 1H165.5C167.709 1 169.5 2.79086 169.5 5V53C169.5 55.2091 167.709 57 165.5 57H6.39263C3.32134 57 1.39587 53.6821 2.91966 51.0154L14.3659 30.9846C15.0686 29.7548 15.0686 28.2452 14.3659 27.0154L2.91966 6.98456Z'
                    fill='#0A6FCD'
                />
            </g>
            <text x='94' y='30' fill='white' textAnchor='middle' dominantBaseline='middle'>
                {text}
            </text>
            <defs>
                <filter
                    id='filter0_d_8996_5767'
                    x='0.386719'
                    y='0'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dy='1' />
                    <feGaussianBlur stdDeviation='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0'
                    />
                    <feBlend
                        mode='normal'
                        in2='BackgroundImageFix'
                        result='effect1_dropShadow_8996_5767'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_dropShadow_8996_5767'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
};
